import { ChampLibreGroup } from "./ChampLibreGroup";
import { IntituleLibreGroup } from "./IntituleLibreGroup";

export class ChampsLibresTexte {

  public txtLibre: ChampLibreGroup;
  public intLibre: IntituleLibreGroup;

  constructor() {
    this.txtLibre = new ChampLibreGroup();
    this.intLibre = new IntituleLibreGroup();
  }
}
